import { useQuery } from '@tanstack/react-query';
import { MapboxOptimizedRoute } from '../../../types/Mapbox';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

interface QueryParams {
  coordinates: string;
}

interface Props {
  params: QueryParams;
  enabled?: boolean;
}

export const fetchOptimizedEventRoute = async ({ params }: Props) => {
  const response = await CustomAxios.get<MapboxOptimizedRoute>('events/optimized_route', { params });
  return response.data;
};

export function useGetOptimizedEventRoute({ params, enabled = true }: Props) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.optimizedEventRoute, params],
    queryFn: () => fetchOptimizedEventRoute({ params }),
  });
}
